// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main-div-1 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.text-area-1 {
    width: 79%;
    border-radius: 8px;
    border: 1px solid #c4c4c4;
    height: 51px;
}

.heading-receiver {
    margin-left: 22px;
    position: absolute !important;
    top: -8px;
    background: #fff;
    z-index: 9;
    padding: 0 3px !important;
}

.carrd-box {
    width: 100%;
}

.my-class-new {

    margin-left: 12px;

}

.text-area-style22 {
    width: 315px;
}

.image-class {
    margin: 12px;
    border: 1px solid #c4c4c4;
    padding: 9px;
    border-radius: 7px;
    min-height: 51px;
    width: 317px;
}

.text-area-style22 {
    width: 317px;
    /* !important; */
}

.image-fix {
    max-width: 320px;
    height: 100px;
    width: 100%;
    object-fit: cover;
    margin-top: 5px;
    border-radius: 4px;

}

/* .auto-resize-textarea {
    resize: vertical;
    min-height: 50px; 
    max-height: 200px;
    overflow-y: scroll; 
    width: 310px;
  } */

.auto-resize-textarea-2 {
    min-height: 50px;
    max-height: 200px;
    overflow-y: scroll;
    max-width: 266px;
    resize: none;
    display: block;
    height: 50px !important;
    padding: 6px 7px;
}

.image-input-class-22[type="file"] {
    height: auto;
    overflow: hidden;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
}

.image-input-class-22[type="file"]+.attach-icon {
    background: #5569ff;
    ;
    border: none;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: 'Rubik', sans-serif;
    font-size: inherit;
    font-weight: 500;
    /* margin-bottom: 1rem; */
    outline: none;
    padding: 1rem 50px;
    position: relative;
    transition: all 0.3s;
    vertical-align: middle;
    width: 268px;
    text-align: center;
    height: 50px;
    display: flex !important;
    align-items: center;
    gap: 2px;
}

input[type="file"]+.attach-icon:hover {
    background-color: darken(#5569ff, 10%);
}


.css-rr8qe2 .MuiTextField-root {
    margin-right: 4px !important;
}

.ok-btn{
    margin-left: 27px !important;
}

.css-rr8qe2 .MuiTextField-root{
    margin:0 !important
}

.css-gzlx6l-MuiPaper-root-MuiCard-root{
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/content/applications/Blog/add-blog/AddBlog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;;AAErB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;;;;;;KAMK;;AAEL;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,mBAAmB;;IAEnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,sCAAsC;AAC1C;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".Main-div-1 {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.text-area-1 {\n    width: 79%;\n    border-radius: 8px;\n    border: 1px solid #c4c4c4;\n    height: 51px;\n}\n\n.heading-receiver {\n    margin-left: 22px;\n    position: absolute !important;\n    top: -8px;\n    background: #fff;\n    z-index: 9;\n    padding: 0 3px !important;\n}\n\n.carrd-box {\n    width: 100%;\n}\n\n.my-class-new {\n\n    margin-left: 12px;\n\n}\n\n.text-area-style22 {\n    width: 315px;\n}\n\n.image-class {\n    margin: 12px;\n    border: 1px solid #c4c4c4;\n    padding: 9px;\n    border-radius: 7px;\n    min-height: 51px;\n    width: 317px;\n}\n\n.text-area-style22 {\n    width: 317px;\n    /* !important; */\n}\n\n.image-fix {\n    max-width: 320px;\n    height: 100px;\n    width: 100%;\n    object-fit: cover;\n    margin-top: 5px;\n    border-radius: 4px;\n\n}\n\n/* .auto-resize-textarea {\n    resize: vertical;\n    min-height: 50px; \n    max-height: 200px;\n    overflow-y: scroll; \n    width: 310px;\n  } */\n\n.auto-resize-textarea-2 {\n    min-height: 50px;\n    max-height: 200px;\n    overflow-y: scroll;\n    max-width: 266px;\n    resize: none;\n    display: block;\n    height: 50px !important;\n    padding: 6px 7px;\n}\n\n.image-input-class-22[type=\"file\"] {\n    height: auto;\n    overflow: hidden;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    opacity: 0;\n}\n\n.image-input-class-22[type=\"file\"]+.attach-icon {\n    background: #5569ff;\n    ;\n    border: none;\n    border-radius: 10px;\n    color: #fff;\n    cursor: pointer;\n    display: inline-block;\n    font-family: 'Rubik', sans-serif;\n    font-size: inherit;\n    font-weight: 500;\n    /* margin-bottom: 1rem; */\n    outline: none;\n    padding: 1rem 50px;\n    position: relative;\n    transition: all 0.3s;\n    vertical-align: middle;\n    width: 268px;\n    text-align: center;\n    height: 50px;\n    display: flex !important;\n    align-items: center;\n    gap: 2px;\n}\n\ninput[type=\"file\"]+.attach-icon:hover {\n    background-color: darken(#5569ff, 10%);\n}\n\n\n.css-rr8qe2 .MuiTextField-root {\n    margin-right: 4px !important;\n}\n\n.ok-btn{\n    margin-left: 27px !important;\n}\n\n.css-rr8qe2 .MuiTextField-root{\n    margin:0 !important\n}\n\n.css-gzlx6l-MuiPaper-root-MuiCard-root{\n    box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
